<template>
    <template v-if="isMobile">
        <BottomSheet :model-value="modelValue" @update:model-value="updateValue">
            <template #content>
                <div class="inline-flex flex-col gap-6 justify-center items-center px-4 pt-3 pb-8 w-full rounded-tl-3xl rounded-tr-3xl bg-neutral-800">
                    <!-- V2.0 Beta 提示内容 -->
                    <template v-if="dialogType === 'v2beta'">
                        <div class="flex flex-col gap-4 justify-center items-start self-stretch px-2">
                            <div class="flex flex-col gap-3 justify-center items-center self-stretch">
                                <div class="w-10 h-1 rounded-full bg-neutral-700"></div>
                                <div class="self-stretch text-xl font-bold leading-normal text-center text-neutral-200">
                                    {{ t('tips.tryV2') }}
                                </div>
                            </div>
                            <div class="flex flex-col gap-3 self-stretch text-neutral-300">
                                <p class="text-base">{{ t('tips.v2Added') }}</p>
                                <div class="text-sm">
                                    <p class="font-semibold mb-2">{{ t('tips.pleaseNote') }}</p>
                                    <ul class="list-disc list-inside space-y-1 text-neutral-400">
                                        <li>{{ t('tips.v2Note1') }}</li>
                                        <li>{{ t('tips.v2Note2') }}</li>
                                        <li>{{ t('tips.v2Note3') }}</li>
                                    </ul>
                                </div>
                                <p class="text-sm text-neutral-400 mt-2">
                                    {{ t('tips.v2Fallback') }}
                                </p>
                            </div>
                        </div>
                    </template>
                    <!-- 原有的上传提示内容 -->
                    <div v-else class="flex flex-col gap-4 justify-center items-center self-stretch h-72">
                        <div class="flex flex-col gap-3 justify-center items-center self-stretch h-10">
                            <div class="w-10 h-1 rounded-full bg-neutral-700"></div>
                            <div class="self-stretch text-base font-semibold leading-normal text-center text-neutral-200">
                                {{ t('tips.title') }}</div>
                        </div>
                        <div class="flex flex-col gap-2 justify-center items-start self-stretch h-28">
                            <div class="inline-flex gap-3 justify-center items-center self-stretch">
                                <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-green-500"
                                    style="background-image: url('/imgs/e1.png'); background-size: cover; background-position: center;">
                                    <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                        <img src="/icon/ic_correct.svg" alt="">
                                    </div>
                                </div>
                                <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-green-500"
                                    style="background-image: url('/imgs/e2.png'); background-size: cover; background-position: center;">
                                    <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                        <img src="/icon/ic_correct.svg" alt="">
                                    </div>
                                </div>
                                <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-green-500"
                                    style="background-image: url('/imgs/e3.png'); background-size: cover; background-position: center;">
                                    <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                        <img src="/icon/ic_correct.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="self-stretch text-xs font-normal leading-none text-center text-neutral-400">
                                {{ t('tips.good') }}</div>
                        </div>
                        <div class="flex flex-col gap-2 justify-center items-start self-stretch h-28">
                            <div class="inline-flex gap-3 justify-center items-center self-stretch">
                                <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-red-500"
                                    style="background-image: url('/imgs/e4.png'); background-size: cover; background-position: center;">
                                    <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                        <img src="/icon/ic_incorrect.svg" alt="">
                                    </div>
                                </div>
                                <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-red-500"
                                    style="background-image: url('/imgs/e5.png'); background-size: cover; background-position: center;">
                                    <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                        <img src="/icon/ic_incorrect.svg" alt="">
                                    </div>
                                </div>
                                <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-red-500"
                                    style="background-image: url('/imgs/e6.png'); background-size: cover; background-position: center;">
                                    <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                        <img src="/icon/ic_incorrect.svg" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="self-stretch text-xs font-normal leading-none text-center text-red-600">
                                {{ t('tips.bad') }}</div>
                        </div>
                    </div>
                    <div v-if="dialogType !== 'v2beta'" class="inline-flex gap-1.5 justify-start items-center self-stretch p-1.5 rounded-md bg-neutral-900/50">
                        <div class="relative w-4 h-4">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2.08325 8.59001C2.08325 4.90801 5.06792 1.92334 8.74992 1.92334C12.4319 1.92334 15.4166 4.90801 15.4166 8.59001C15.4166 12.272 12.4319 15.2567 8.74992 15.2567C5.06792 15.2567 2.08325 12.272 2.08325 8.59001ZM8.74992 9.25667C8.57311 9.25667 8.40354 9.18643 8.27851 9.06141C8.15349 8.93639 8.08325 8.76682 8.08325 8.59001V5.92334C8.08325 5.74653 8.15349 5.57696 8.27851 5.45194C8.40354 5.32691 8.57311 5.25667 8.74992 5.25667C8.92673 5.25667 9.0963 5.32691 9.22132 5.45194C9.34635 5.57696 9.41658 5.74653 9.41658 5.92334V8.59001C9.41658 8.76682 9.34635 8.93639 9.22132 9.06141C9.0963 9.18643 8.92673 9.25667 8.74992 9.25667ZM7.74992 11.2567C7.74992 10.9915 7.85528 10.7371 8.04281 10.5496C8.23035 10.362 8.4847 10.2567 8.74992 10.2567H8.75659C9.0218 10.2567 9.27616 10.362 9.46369 10.5496C9.65123 10.7371 9.75659 10.9915 9.75659 11.2567V11.2633C9.75659 11.5286 9.65123 11.7829 9.46369 11.9704C9.27616 12.158 9.0218 12.2633 8.75659 12.2633H8.74992C8.4847 12.2633 8.23035 12.158 8.04281 11.9704C7.85528 11.7829 7.74992 11.5286 7.74992 11.2633V11.2567Z"
                                    fill="#737373" />
                            </svg>
                        </div>
                        <div class="text-xs font-normal grow shrink basis-0 text-neutral-500">
                            {{ t('tips.noteBefore') }} <a href="/content-monitoring-policy" target="_blank" class="text-orange-600 hover:underline">{{ t('tips.policyLink') }}</a>
                        </div>
                    </div>
                    <div v-if="showBottomBtn && showToggle" @click="showAgainToggle"
                        class="inline-flex gap-1.5 justify-start items-center p-1.5 w-full rounded-md cursor-pointer">
                        <v-icon v-if="canShowTipsPopup" icon="mdi-radiobox-blank mr-1 text-neutral-500"></v-icon>
                        <v-icon v-else icon="mdi-checkbox-marked-circle mr-1 text-neutral-500"></v-icon>
                        <div class="text-xs font-normal leading-none grow shrink basis-0 text-neutral-500">
                            {{ t('tips.dontShowAgain') }}
                        </div>
                    </div>
                    <div @click="handleConfirm" v-if="showBottomBtn"
                        class="inline-flex gap-1.5 justify-center items-center self-stretch px-5 py-3 bg-orange-600 rounded-full cursor-pointer">
                        <div class="text-lg font-semibold leading-7 text-center text-neutral-950">{{ t('tips.ok') }}</div>
                    </div>
                </div>
            </template>
        </BottomSheet>
    </template>
    <template v-else>
        <Dialog :model-value="modelValue" @update:model-value="updateValue" width="600px" :show-close="true">
            <template #content>
                <div class="p-4 rounded-3xl bg-neutral-800">
                    <div class="flex flex-col gap-6 justify-center items-center w-full">
                        <!-- V2.0 Beta 提示内容 -->
                        <template v-if="dialogType === 'v2beta'">
                            <div class="flex flex-col gap-4 justify-center items-start self-stretch px-2">
                                <div class="self-stretch text-2xl font-bold leading-normal text-center text-neutral-200">
                                    {{ t('tips.tryV2') }}
                                </div>
                                <div class="flex flex-col gap-4 self-stretch text-neutral-300">
                                    <p class="text-lg">{{ t('tips.v2Added') }}</p>
                                    <div class="text-base">
                                        <p class="font-semibold mb-3">{{ t('tips.pleaseNote') }}</p>
                                        <ul class="list-disc list-inside space-y-2 text-neutral-400">
                                            <li>Currently only supports videos up to 1 minute long</li>
                                            <li>Processing may be slower than in V1.0</li>
                                            <li>Results may be unstable during beta</li>
                                        </ul>
                                    </div>
                                    <p class="text-sm text-neutral-400 mt-2">
                                        {{ t('tips.v2Fallback') }}
                                    </p>
                                </div>
                            </div>
                        </template>
                        <!-- 原有的上传提示内容 -->
                        <div v-else class="flex flex-col gap-4 justify-center items-center self-stretch h-72">
                            <div class="flex flex-col gap-3 justify-center items-center self-stretch h-10">
                                <div class="self-stretch text-base font-semibold leading-normal text-center text-neutral-200">
                                    {{ t('tips.title') }}</div>
                            </div>
                            <div class="flex flex-col gap-2 justify-center items-start self-stretch h-28">
                                <div class="inline-flex gap-3 justify-center items-center self-stretch">
                                    <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-green-500"
                                        style="background-image: url('/imgs/e1.png'); background-size: cover; background-position: center;">
                                        <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                            <img src="/icon/ic_correct.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-green-500"
                                        style="background-image: url('/imgs/e2.png'); background-size: cover; background-position: center;">
                                        <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                            <img src="/icon/ic_correct.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-green-500"
                                        style="background-image: url('/imgs/e3.png'); background-size: cover; background-position: center;">
                                        <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                            <img src="/icon/ic_correct.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="self-stretch text-xs font-normal leading-none text-center text-neutral-400">
                                    {{ t('tips.good') }}</div>
                            </div>
                            <div class="flex flex-col gap-2 justify-center items-start self-stretch h-28">
                                <div class="inline-flex gap-3 justify-center items-center self-stretch">
                                    <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-red-500"
                                        style="background-image: url('/imgs/e4.png'); background-size: cover; background-position: center;">
                                        <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                            <img src="/icon/ic_incorrect.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-red-500"
                                        style="background-image: url('/imgs/e5.png'); background-size: cover; background-position: center;">
                                        <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                            <img src="/icon/ic_incorrect.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="flex justify-end items-center pt-16 pr-1 pb-1 pl-20 h-24 rounded-xl border-2 border-red-500"
                                        style="background-image: url('/imgs/e6.png'); background-size: cover; background-position: center;">
                                        <div class="flex relative flex-col justify-start items-start w-6 h-6">
                                            <img src="/icon/ic_incorrect.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="self-stretch text-xs font-normal leading-none text-center text-red-600">
                                    {{ t('tips.bad') }}</div>
                            </div>
                        </div>
                        <div v-if="dialogType !== 'v2beta'" class="inline-flex gap-1.5 justify-start items-center self-stretch p-1.5 rounded-md bg-neutral-900/50">
                            <div class="relative w-4 h-4">
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M2.08325 8.59001C2.08325 4.90801 5.06792 1.92334 8.74992 1.92334C12.4319 1.92334 15.4166 4.90801 15.4166 8.59001C15.4166 12.272 12.4319 15.2567 8.74992 15.2567C5.06792 15.2567 2.08325 12.272 2.08325 8.59001ZM8.74992 9.25667C8.57311 9.25667 8.40354 9.18643 8.27851 9.06141C8.15349 8.93639 8.08325 8.76682 8.08325 8.59001V5.92334C8.08325 5.74653 8.15349 5.57696 8.27851 5.45194C8.40354 5.32691 8.57311 5.25667 8.74992 5.25667C8.92673 5.25667 9.0963 5.32691 9.22132 5.45194C9.34635 5.57696 9.41658 5.74653 9.41658 5.92334V8.59001C9.41658 8.76682 9.34635 8.93639 9.22132 9.06141C9.0963 9.18643 8.92673 9.25667 8.74992 9.25667ZM7.74992 11.2567C7.74992 10.9915 7.85528 10.7371 8.04281 10.5496C8.23035 10.362 8.4847 10.2567 8.74992 10.2567H8.75659C9.0218 10.2567 9.27616 10.362 9.46369 10.5496C9.65123 10.7371 9.75659 10.9915 9.75659 11.2567V11.2633C9.75659 11.5286 9.65123 11.7829 9.46369 11.9704C9.27616 12.158 9.0218 12.2633 8.75659 12.2633H8.74992C8.4847 12.2633 8.23035 12.158 8.04281 11.9704C7.85528 11.7829 7.74992 11.5286 7.74992 11.2633V11.2567Z"
                                        fill="#737373" />
                                </svg>
                            </div>
                            <div class="text-xs font-normal leading-none grow shrink basis-0 text-neutral-500">
                                {{ t('tips.noteBefore') }} <a href="/content-monitoring-policy" target="_blank" class="text-orange-600 hover:underline">{{ t('tips.policyLink') }}</a>
                            </div>
                        </div>
                        <div v-if="showBottomBtn && showToggle" @click="showAgainToggle"
                            class="inline-flex gap-1.5 justify-start items-center p-1.5 w-full rounded-md cursor-pointer">
                            <v-icon v-if="canShowTipsPopup" icon="mdi-radiobox-blank mr-1 text-neutral-500"></v-icon>
                            <v-icon v-else icon="mdi-checkbox-marked-circle mr-1 text-neutral-500"></v-icon>
                            <div class="text-xs font-normal leading-none grow shrink basis-0 text-neutral-500">
                                {{ t('tips.dontShowAgain') }}
                            </div>
                        </div>
                        <div @click="handleConfirm" v-if="showBottomBtn"
                            class="inline-flex gap-1.5 justify-center items-center self-stretch px-5 py-3 bg-orange-600 rounded-full cursor-pointer">
                            <div class="text-lg font-semibold leading-7 text-center text-neutral-950">{{ t('tips.ok') }}</div>
                        </div>
                    </div>
                </div>
            </template>
        </Dialog>
    </template>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import { useDisplay } from 'vuetify';
import Dialog from '@/components/Dialog.vue';
import BottomSheet from '@/components/BottomSheet.vue';
import { useCommStore } from '@/composables/useCommStore';

const display = useDisplay();
const isMobile = computed(() => display.xs.value);
const comm = useCommStore();
const { t } = useI18n();

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    showBottomBtn: {
        type: Boolean,
        default: true
    },
    showToggle: {
        type: Boolean,
        default: true
    },
    dialogType: {
        type: String as PropType<'info' | 'upload' | 'v2beta'>,
        default: 'info'
    }
});

const emit = defineEmits(['update:modelValue', 'confirm']);

const canShowTipsPopup = computed(() => comm.appInfo.canShowTipsPopup);

const showAgainToggle = () => {
    if (!props.showToggle) return;
    comm.setAppInfo({ canShowTipsPopup: !comm.appInfo.canShowTipsPopup });
};

const handleConfirm = () => {
    if (!props.showToggle || comm.appInfo.canShowTipsPopup) {
        emit('update:modelValue', false);
        emit('confirm');
    } else {
        emit('update:modelValue', false);
    }
};

const updateValue = (value: boolean) => {
    emit('update:modelValue', value);
};
</script> 